import { gql } from '@provision/graphql-client';
import { CONVERSATION_MESSAGE_DRAFT_FRAGMENT } from './conversation-message-draft.fragments';

export const GET_CONVERSATION_MESSAGE_DRAFT_QUERY = gql`
  query GetUserConversationMessageDraft($params: GetUserConversationMessageDraftInput) {
    getUserConversationMessageDraft(params: $params) {
      records {
        ...ConversationMessageDraftFields
      }
    }
  }
  ${CONVERSATION_MESSAGE_DRAFT_FRAGMENT}
`;

export const UPSERT_CONVERSATION_MESSAGE_DRAFT_QUERY = gql`
  mutation UpsertConversationMessageDraft($params: UpsertConversationMessageDraftInput!) {
    upsertConversationMessageDraft(params: $params) {
      ...ConversationMessageDraftFields
    }
  }
  ${CONVERSATION_MESSAGE_DRAFT_FRAGMENT}
`;

export const DELETE_CONVERSATION_MESSAGE_DRAFT = gql`
  mutation DeleteConversationMessageDraft($conditions: [ConditionInput!]!) {
    deleteConversationMessageDraft(conditions: $conditions) {
      id
    }
  }
`;
